import { logError } from '@edx/frontend-platform/logging';
import {
  sendReview,
  shouldRequestFromUser,
} from './api';

import {
  fetchDialogFailure,
  fetchDialogRequest,
  fetchDialogSuccess, fetchReviewFailure, fetchReviewRequest, fetchReviewSuccess,
} from './slice';

export function fetchDialog(courseId, username) {
  return async (dispatch) => {
    dispatch(fetchDialogSuccess({ shouldShowDialog: false }));
    // dispatch(fetchDialogRequest());
    // shouldRequestFromUser(courseId, username).then((result) => {
    //   console.log(result);
    //   if (result.status === 200) {
    //     dispatch(fetchDialogSuccess({ shouldShowDialog: result.data.shouldRequestFromUser }));
    //     console.log('Thunk:', result.data.shouldRequestFromUser);
    //   } else {
    //     dispatch(fetchDialogFailure());
    //     logError(result.reason);
    //   }
    // });
  };
}

export function fetchReview(courseId, rating, comment, username) {
  return async (dispatch) => {
    dispatch(fetchReviewRequest());
    sendReview(courseId, rating, comment, username).then((result) => {
      if (result.status === 200) {
        dispatch(fetchReviewSuccess());
      } else {
        dispatch(fetchReviewFailure());
        logError(result.reason);
      }
    });
  };
}
